export const LEGAL_CONTENT_CLASSES =
  "text-sm text-gray-700 leading-relaxed [&_h1]:text-2xl [&_h1]:font-bold [&_h1]:mb-3 " +
  "[&_h2]:text-xl [&_h2]:font-bold [&_h2]:mt-6 [&_h2]:mb-2 " +
  "[&_h3]:text-lg [&_h3]:font-semibold [&_h3]:mt-4 [&_h3]:mb-1 " +
  "[&_p]:my-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6 " +
  "[&_li]:mb-1.5 [&_a]:text-primary-600 [&_a]:underline " +
  "[&_strong]:font-semibold [&_blockquote]:border-l-4 [&_blockquote]:border-gray-200 " +
  "[&_blockquote]:pl-4 [&_blockquote]:text-gray-500";